import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Alert, Button, Container, Form, Table } from 'react-bootstrap';
import { authFetch } from '../utils/authFetch';

const number = n => Number(n).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
export default function CostAllocationReport() {
  const now = new Date();
  const [from, setFrom] = useState(`${now.getFullYear()}-${String(now.getMonth()+1).padStart(2, '0')}-01`);
  const [to, setTo] = useState(`${now.getFullYear()}-${String(now.getMonth()+1).padStart(2, '0')}-${String(now.getDate()).padStart(2, '0')}`);
  const [data, setData] = useState(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [onlyMissing, setOnlyMissing] = useState(true);
  async function load() {
    setBusy(true); setError('');
    try { setData(await authFetch(`/repartizari-centre/control?date_from=${from}&date_to=${to}`)); }
    catch (e) { setError(e.message); } finally { setBusy(false); }
  }
  useEffect(() => { load(); }, []); // eslint-disable-line react-hooks/exhaustive-deps
  return <Container className="py-4"><h2>Controlul repartizării pe centre</h2>
    <p>Cheltuieli și venituri din contabilitate, comparate cu repartizările. Închiderea conturilor prin 121 este exclusă. Diferențele se verifică și pe document, pentru a nu compensa lipsuri între ele.</p>
    <Form onSubmit={e => { e.preventDefault(); load(); }} className="d-flex gap-2 mb-3">
      <Form.Control type="date" aria-label="De la" value={from} onChange={e => setFrom(e.target.value)} required />
      <Form.Control type="date" aria-label="Până la" value={to} onChange={e => setTo(e.target.value)} required />
      <Button type="submit" disabled={busy}>Verifică</Button>
    </Form>
    {error && <Alert variant="danger">{error}</Alert>}
    {data && !data.enabled && <Alert variant="info">Firma nu folosește repartizarea pe centre. Diferențele afișate nu blochează documentele.</Alert>}
    {data && <><Table bordered responsive><thead><tr><th>Cont</th><th>Contabilitate</th><th>Repartizat</th><th>Diferență</th><th>Linii de verificat</th></tr></thead><tbody>
      {data.accounts.map(a => <tr key={a.account_id} className={a.uncovered ? 'table-warning' : ''}><td>{a.code} — {a.name}</td><td>{number(a.base)}</td><td>{number(a.allocated)}</td><td>{number(a.difference)}</td><td>{a.uncovered}</td></tr>)}
    </tbody></Table>
    <Form.Check label="Numai liniile cu diferențe" checked={onlyMissing} onChange={e => setOnlyMissing(e.target.checked)} className="my-3" />
    <Table bordered responsive><thead><tr><th>Document</th><th>Linie / cont</th><th>Contabilitate</th><th>Repartizat</th><th>Diferență</th></tr></thead><tbody>
      {data.documents.filter(g => !onlyMissing || Number(g.difference) !== 0).map(g => <tr key={`${g.rec_type}-${g.doc_id}-${g.doc_lns_id}-${g.account_id}`}>
        <td><Link to={`/nc/view/${g.rec_type}/${g.doc_id}`}>{g.doc_no} · {String(g.data_nc).slice(0, 10)}</Link></td><td>{g.doc_lns_id} / {g.code}</td><td>{number(g.base)}</td><td>{number(g.allocated)}</td><td>{number(g.difference)}</td>
      </tr>)}
    </tbody></Table></>}
  </Container>;
}
